<template>
  <section v-if="userProfile" class="leaderboard-public-user-profile-container">
    <div class="user-profile-info">
      <p class="club">
        Club:
        <span v-if="userProfile.profile.mainClubName">{{
          userProfile.profile.mainClubName
        }}</span>
        <span v-else-if="userProfile.profile.club">{{
          userProfile.profile.club
        }}</span>
        <span v-else>-</span>
      </p>
      <p class="pdga">
        PDGA:
        <span v-if="userProfile.profile.pdgaNumber">{{
          userProfile.profile.pdgaNumber
        }}</span>
        <span v-else>-</span>
        <span class="round-separator"> </span>Rating:
        <span v-if="userProfile.profile.pdgaNumber">{{
          userProfile.profile.pdgaRating
        }}</span>
        <span v-else> - </span>
      </p>
      <div class="links">
        <router-link
          target="_blank"
          :to="{ name: 'public-user', params: { userId: player.userId } }"
        >
          <p class="view-full-profile">View full profile</p></router-link
        >
        <template v-if="watched !== undefined">
          <p class="round-separator"></p>
          <div
            @click="$emit('toggleWatchPlayer')"
            class="watch-player unwatch"
            v-if="watched"
          >
            <p>Stop watching</p>
          </div>
          <div class="watch-player" @click="$emit('toggleWatchPlayer')" v-else>
            <p>Watch player</p>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LeaderboardUserProfile',
  props: ['player', 'watched'],
  data() {
    return {
      userProfile: null,
    }
  },
  computed: {},
  methods: {
    async loadUserProfile(userId) {
      try {
        const userprofileData = await this.$axios({
          data: {
            query: `
              {
                user(userId:"${userId}"){
                  id
                  firstName
                  lastName
                  profile{
                    mainClubName
                    club
                    pdgaNumber
                    pdgaNumber
                    pdgaRating
                  }
                }
              }
            `,
          },
        })

        this.userProfile = userprofileData.data.data.user
      } catch (err) {
        console.log(err)
        this.$store.dispatch('showMessage', {
          show: true,
          message: 'Error loading user data',
          type: 'error',
        })
      }
    },
  },
  beforeMount() {
    if (this.player) {
      this.loadUserProfile(this.player.userId)
    }
  },
  beforeCreate() {},
  destroyed() {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/Typography';

a:hover {
  text-decoration: none;
}

.leaderboard-public-user-profile-container {
  width: 100%;
  display: flex;
}
.avatar-wrapper {
  margin: 0 12px 0 0px;
}
.user-profile-info {
  p {
    font-size: 00.875rem;
    line-height: 1.25rem;
    color: $strom;
    margin-bottom: 4px;

    span {
      color: $midnight;
    }
  }

  .links {
    display: flex;
  }

  .view-full-profile {
    color: $ocean;
    cursor: pointer;
  }
  .watch-player {
    cursor: pointer;
    p {
      color: $twilight;
    }
  }
}

@media (min-width: 600px) {
  .leaderboard-public-user-profile-container {
    display: block;
    .club,
    .pdga,
    .sponsors {
      display: none;
    }
    .links {
      margin-top: 8px;
    }
  }
}

@media (min-width: 1024px) {
  .leaderboard-public-user-profile-container {
    display: flex;
    .club,
    .pdga,
    .sponsors {
      display: block;
    }
    .links {
      margin-top: 0px;
    }
  }
}

@media (min-width: 1200px) {
  .avatar-wrapper {
    margin: 0 16px 0 15px;
  }
  .links {
    flex-direction: column;
    .round-separator {
      display: none;
    }
  }
}
</style>
